

export const InputFocusedContextKey = 'inputFocus';
